/**
 * Printer class definition.  Used to interface with Stencil.
 */

$(() => {
  function Printer() {
    window.StencilWebAPI.PrinterBase.call(this);
  }
  Printer.prototype = Object.create(window.StencilWebAPI.PrinterBase.prototype);
  Printer.prototype.constructor = Printer;
  window.Printer = Printer;
});
